import { API_URL } from '../utils/apiConfig';
import { invalidateFolderQueries, invalidateDocumentQueries } from '../utils/queryClient';

class FolderService {
  async createFolder(name, parentId = null) {
    const response = await fetch(`${API_URL}/folders`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ name, parentId })
    });

    if (!response.ok) {
      throw new Error('Failed to create folder');
    }

    const result = await response.json();
    
    // ✅ CACHE INVALIDATION: Invalidate folder queries after creation
    invalidateFolderQueries();
    console.log('🔄 Cache invalidated after folder creation');
    
    return result;
  }

  async getFolder(folderId) {
    const response = await fetch(`${API_URL}/folders/${folderId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to get folder');
    }

    return await response.json();
  }

  async getUserFolders(parentId = null) {
    const url = parentId 
      ? `${API_URL}/folders?parentId=${parentId}`
      : `${API_URL}/folders`;

    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to get folders');
    }

    return await response.json();
  }

  async updateFolder(folderId, updates) {
    const response = await fetch(`${API_URL}/folders/${folderId}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(updates)
    });

    if (!response.ok) {
      throw new Error('Failed to update folder');
    }

    const result = await response.json();
    
    // ✅ CACHE INVALIDATION: Invalidate folder queries after update
    invalidateFolderQueries();
    console.log('🔄 Cache invalidated after folder update');
    
    return result;
  }

  async deleteFolder(folderId) {
    const response = await fetch(`${API_URL}/folders/${folderId}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      }
    });

    if (!response.ok) {
      throw new Error('Failed to delete folder');
    }
    
    // ✅ CACHE INVALIDATION: Invalidate folder and document queries after deletion
    invalidateFolderQueries();
    invalidateDocumentQueries();
    console.log('🔄 Cache invalidated after folder deletion');
  }

  async moveDocument(documentId, folderId) {
    const response = await fetch(`${API_URL}/folders/documents/${documentId}/move`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ folderId })
    });

    if (!response.ok) {
      throw new Error('Failed to move document');
    }

    const result = await response.json();
    
    // ✅ CACHE INVALIDATION: Invalidate both folder and document queries after moving
    invalidateFolderQueries();
    invalidateDocumentQueries();
    console.log('🔄 Cache invalidated after document move');
    
    return result;
  }

  async moveFolder(folderId, newParentId) {
    const response = await fetch(`${API_URL}/folders/${folderId}/move`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ newParentId })
    });

    if (!response.ok) {
      throw new Error('Failed to move folder');
    }

    const result = await response.json();
    
    // ✅ CACHE INVALIDATION: Invalidate folder queries after folder move
    invalidateFolderQueries();
    console.log('🔄 Cache invalidated after folder move');
    
    return result;
  }
}

export const folderService = new FolderService(); 